module.exports = __webpack_public_path__ + "components/flag/static/square/vu-7abe2b2f8ddc7d5517e666abe4e7575b.svg";